module.exports = __webpack_public_path__ + "static/media/footerBGR.deecf55d.png";